export default __webpack_public_path__ + "static/media/free_board_banner.f55382ee.png";